import type { Messages } from './index';

export const de: Messages = {
  // Common
  'common.done': 'Fertig',
  'common.cancel': 'Abbrechen',
  'common.close': 'Schließen',
  'common.copy': 'Kopieren',
  'common.copied': 'Kopiert',
  'common.untitled': 'Ohne Titel',
  'common.ok': 'OK',
  'common.save': 'Speichern',

  // Toolbar
  'toolbar.toggleSidebar': 'Seitenleiste umschalten (Cmd/Strg+\\)',
  'toolbar.toggleOutline': 'Gliederung umschalten (Inhaltsverzeichnis)',
  'toolbar.docTitle': 'Dokumenttitel',
  'toolbar.source': 'Quelle',
  'toolbar.preview': 'Vorschau',
  'toolbar.pane': 'Bereich',
  'toolbar.split': 'Geteilt',
  'toolbar.switch': 'Wechseln',
  'split.resize': 'Aufteilung anpassen — Pfeiltasten, Doppelklick für 50/50',
  'toolbar.toggleView': 'Ansicht umschalten (Cmd/Strg+Umschalt+V)',
  'toolbar.vim': 'Vim',
  'toolbar.toggleVim': 'Vim-Modus umschalten',
  'toolbar.cycleTheme': 'Design wechseln',
  'toolbar.export': 'Export',
  'toolbar.share': 'Teilen',
  'toolbar.sharing': 'Teile…',
  'toolbar.shareTitle': 'Schreibgeschützten Link erstellen',
  'toolbar.shareOptions': 'Teilen-Optionen (Zugriff + Ablauf)',
  'toolbar.settings': 'Einstellungen',
  'toolbar.palette': 'Befehlspalette (Cmd/Strg+K)',
  'toolbar.more': 'Mehr',

  // Save state
  'save.saved': 'Lokal gespeichert',
  'save.saving': 'Speichere…',
  'save.offline': 'Offline',

  // Theme labels
  'theme.auto': 'Auto',
  'theme.light': 'Hell',
  'theme.dark': 'Dunkel',

  // Export formats
  'export.failed': 'Export fehlgeschlagen',
  'export.md': 'Markdown (.md)',
  'export.html': 'HTML',
  'export.pdf': 'PDF',
  'export.docx': 'Word (DOCX)',
  'export.slides': 'Folien (HTML)',

  // Sidebar
  'sidebar.search': 'Titel & Text durchsuchen…',
  'sidebar.searchAria': 'Dokumente nach Titel und Inhalt durchsuchen',
  'sidebar.import': 'Markdown-Datei(en) importieren',
  'sidebar.new': 'Neues Dokument (Cmd/Strg+N)',
  'sidebar.newMore': 'Weitere Wege, ein Dokument hinzuzufügen',
  'sidebar.newTemplate': 'Neu aus Vorlage…',
  'sidebar.upload': 'Datei(en) hochladen…',
  'sidebar.importUrl': 'Von URL importieren…',

  // Tags
  'tags.title': 'Tags bearbeiten',
  'tags.edit': 'Tags bearbeiten',
  'tags.none': 'Noch keine Tags.',
  'tags.placeholder': 'Tag hinzufügen und Enter drücken',
  'tags.remove': 'Tag {tag} entfernen',
  'tags.all': 'Alle',
  'tags.filterAria': 'Dokumente nach Tag filtern',
  'cmd.doc.tags': 'Tags bearbeiten…',
  'cmd.doc.rename': 'Dokument umbenennen',
  'cmd.doc.move': 'In Ordner verschieben…',

  // Import from URL
  'import.zip.invalid': '{name} ließ sich nicht öffnen: Es ist kein lesbares ZIP-Archiv.',
  'import.zip.too_large': '{name} ließ sich nicht öffnen: Es ist zu groß für den Import.',
  'import.zip.unsupported':
    '{name} ließ sich nicht öffnen: Es ist verschlüsselt oder nutzt eine nicht unterstützte Kompression.',
  'import.title': 'Markdown importieren',
  'import.hint':
    'Füge Markdown-, Text-, Word- oder HTML-Dateien zu deiner Bibliothek hinzu — ein Dokument je Datei. Word und HTML werden auf deinem Gerät in Markdown umgewandelt. Ein Notion-Export (.zip) oder ein Evernote-Export (.enex) kommt als ganzer Satz Notizen herein.',
  'import.drop': 'Dateien hierher ziehen',
  'import.browse': 'oder klicken, um Dateien auszuwählen',
  'import.formats':
    'Akzeptiert .md, .markdown, .mdown, .mkd, .mdwn, .txt, .docx, .html und .enex — oder ein .zip davon, samt Ordnern',
  'import.importing': 'Wird importiert…',
  'import.skipped': 'Nicht importiert, weil es keine Text-, Word- oder HTML-Dateien sind: {files}',
  'import.failedTitle': 'Einige Dateien ließen sich nicht umwandeln',
  'import.failed': 'Nicht umwandelbar, womöglich beschädigt: {files}',
  'import.overlay': 'Markdown-Dateien zum Importieren ablegen',
  'importUrl.title': 'Von URL importieren',
  'importUrl.hint': 'Füge einen Link zu einem Markdown- oder Textdokument ein.',
  'importUrl.import': 'Importieren',
  'importUrl.importing': 'Importiere…',
  'importUrl.failed': 'Import fehlgeschlagen.',
  'cmd.doc.importUrl': 'Von URL importieren…',
  'sidebar.pin': 'Oben anheften',
  'sidebar.unpin': 'Lösen',
  'sidebar.rename': 'Umbenennen',
  'sidebar.more': 'Weitere Aktionen',
  'sidebar.duplicate': 'Duplizieren',
  'sidebar.delete': 'Löschen',
  'sidebar.emptyNoMatch': 'Keine Dokumente passen zur Suche.',
  'sidebar.empty': 'Noch keine Dokumente.',
  'sidebar.loading': 'Bibliothek wird geladen …',
  'tab.close': 'Tab schließen',
  'tab.closeOthers': 'Andere Tabs schließen',
  'folder.move': 'In Ordner verschieben',
  'folder.root': 'Wurzel (kein Ordner)',
  'folder.new': 'Neuer Ordner',
  'folder.newPlaceholder': 'Neuer Ordner (/ für Verschachtelung)…',
  'folder.create': 'Hierher verschieben',
  'folder.rename': 'Ordner umbenennen',
  'folder.renamePrompt': 'Ordner umbenennen in:',
  'folder.dropToRoot': 'Hierhin ziehen, um aus dem Ordner zu lösen',
  'sidebar.resize': 'Seitenleiste anpassen — Pfeiltasten, Doppelklick setzt zurück',
  'sidebar.sort': 'Sortieren',
  'sidebar.sortUpdated': 'Zuletzt geändert',
  'sidebar.sortCreated': 'Erstellungsdatum',
  'sidebar.sortTitle': 'Titel (A–Z)',
  'sidebar.sortManual': 'Manuell (per Ziehen ordnen)',
  'sidebar.moveUp': 'Nach oben',
  'sidebar.moveDown': 'Nach unten',
  'sidebar.trash': 'Papierkorb …',

  // Status bar
  'status.words': '{n} Wörter',
  'status.chars': '{n} Zeichen',
  'status.lines': '{n} Zeilen',
  'status.reading': '{n} Min. Lesezeit',

  // Settings
  'settings.title': 'Einstellungen',
  'settings.theme': 'Design',
  'settings.fontSize': 'Editor-Schriftgröße',
  'settings.decrease': 'Schrift verkleinern',
  'settings.increase': 'Schrift vergrößern',
  'settings.lineNumbers': 'Zeilennummern',
  'settings.vim': 'Vim-Modus',
  'settings.typewriter': 'Schreibmaschinen-Scrollen',
  'settings.exportTheme': 'Export-Design (HTML/PDF)',
  'settings.language': 'Sprache',
  'lang.auto': 'System',
  'lang.en': 'English',
  'lang.de': 'Deutsch',

  // Outline
  'outline.title': 'Gliederung',
  'outline.close': 'Gliederung schließen',
  'outline.empty': 'Noch keine Überschriften. Füge eine „# Überschrift“ hinzu.',
  'outline.backlinks': 'Verweise hierauf',
  'outline.noBacklinks': 'Noch keine Verweise. Nutze [[Titel]] zum Verlinken.',

  // Focus mode
  'focus.exit': 'Fokus verlassen',
  'focus.exitTitle': 'Fokusmodus verlassen (Esc)',

  // Crash screen
  'crash.title': 'Etwas ist schiefgelaufen',
  'crash.body':
    'markbird hatte einen unerwarteten Fehler. Deine Dokumente sind auf diesem Gerät sicher — ein Neuladen hilft meist.',
  'crash.reload': 'markbird neu laden',
  'crash.continue': 'Weiter versuchen',

  // Share dialog
  'share.readTitle': 'Schreibgeschützter Link erstellt',
  'share.editTitle': 'Bearbeitbarer Link erstellt',
  'share.copiedRead':
    'In die Zwischenablage kopiert. Jeder mit diesem Link kann eine Momentaufnahme dieses Dokuments ansehen. Beim Teilen wird der Inhalt auf EU-Server kopiert.',
  'share.copiedEdit':
    'In die Zwischenablage kopiert. Jeder mit diesem Link kann die geteilte Kopie dieses Dokuments bearbeiten. Du kannst ihn jederzeit unter „Geteilte Links“ verwalten oder widerrufen. Beim Teilen wird der Inhalt auf EU-Server kopiert.',
  'share.send': 'Teilen…',
  'share.sheetTitle': 'Eine Notiz aus markbird',
  'share.openLink': 'Link öffnen',
  'share.failTitle': 'Link konnte nicht erstellt werden',
  'share.empty': 'Nichts zu teilen — das Dokument ist leer.',

  // Share options dialog
  'shareOpt.title': 'Teilen-Optionen',
  'shareOpt.access': 'Zugriff',
  'shareOpt.read': 'Schreibgeschützt',
  'shareOpt.edit': 'Bearbeitbar',
  'shareOpt.editSignin': 'Bearbeitbar (Anmeldung nötig)',
  'shareOpt.expires': 'Läuft ab',
  'shareOpt.never': 'Nie',
  'shareOpt.1h': '1 Stunde',
  'shareOpt.1d': '1 Tag',
  'shareOpt.7d': '7 Tage',
  'shareOpt.30d': '30 Tage',
  'shareOpt.password': 'Passwort',
  'shareOpt.passwordPlaceholder': 'Optional — leer lassen für keins',
  'shareOpt.slug': 'Eigener Link',
  'shareOpt.slugPlaceholder': 'z. B. launch-notes (optional) → /p/…',
  'shareOpt.create': 'Link erstellen',
  'shareOpt.creating': 'Erstelle…',
  'shareOpt.explainer':
    'Beim Erstellen eines Links wird eine Kopie dieses Dokuments auf die Server von markbird hochgeladen, damit Empfänger es öffnen können. Jeder mit dem Link kann es ansehen; ein Passwort schränkt den Zugriff ein. Du kannst ein Ablaufdatum setzen oder den Link jederzeit widerrufen.',

  // Share manager
  'shareMgr.title': 'Deine geteilten Links',
  'shareMgr.explainer':
    'Diese Links verweisen jeweils auf eine Kopie eines Dokuments auf den Servern von markbird. Jeder mit einem Link kann es öffnen, bis es abläuft oder du es widerrufst.',
  'shareMgr.setExpiry': 'Ablauf ändern…',
  'shareMgr.signin': 'Melde dich an, um deine geteilten Links zu verwalten.',
  'shareMgr.loadFail': 'Geteilte Links konnten nicht geladen werden.',
  'shareMgr.empty':
    'Keine aktiven Links. Nutze „Teilen“, um einen schreibgeschützten oder bearbeitbaren Link zu erstellen.',
  'shareMgr.badgeEdit': 'Bearbeitbar',
  'shareMgr.badgeRead': 'Schreibgeschützt',
  'shareMgr.isSite': 'Website',
  'shareMgr.expires': 'läuft ab {date}',
  'shareMgr.copyLink': 'Link kopieren',
  'shareMgr.revoke': 'Widerrufen',
  'shareMgr.revoking': 'Widerrufe…',
  'shareMgr.protected': 'Passwortgeschützt',

  // Trash
  'trash.title': 'Papierkorb',
  'trash.note':
    'Gelöschte Dokumente bleiben hier, bis du sie wiederherstellst oder endgültig löschst.',
  'trash.empty': 'Der Papierkorb ist leer.',
  'trash.restore': 'Wiederherstellen',
  'trash.deleteForever': 'Endgültig löschen',
  'trash.deleteConfirm': '„{title}“ endgültig löschen? Das kann nicht rückgängig gemacht werden.',
  'trash.emptyAll': 'Papierkorb leeren',
  'trash.emptyConfirm':
    'Alle Dokumente im Papierkorb endgültig löschen? Das kann nicht rückgängig gemacht werden.',
  'trash.deletedAt': 'gelöscht {date}',

  // Templates
  'tpl.title': 'Neu aus Vorlage',
  'tpl.note': 'Starte ein Dokument mit einer fertigen Struktur.',
  'tpl.blank': 'Leeres Dokument',
  'tpl.daily': 'Tagesnotiz',
  'tpl.meeting': 'Besprechungsnotizen',
  'tpl.blog': 'Blogbeitrag',
  'tpl.todo': 'To-do-Liste',
  'tpl.readme': 'Projekt-README',

  // Backups
  'cmd.site.publish': 'Ordner als Website veröffentlichen…',
  'cmd.folderSync.now': 'Dateien jetzt synchronisieren',
  'cmd.appearance.customCss': 'Eigenes CSS bearbeiten…',
  'cmd.appearance.disableCustomCss': 'Eigenes CSS ausschalten',
  'query.empty': 'Keine Notiz passt zu dieser Abfrage.',
  'query.count': '{n} Notiz(en)',
  'query.problems': 'Nicht verstanden: {what}',
  'query.emptyTasks': 'Keine Aufgabe passt zu dieser Abfrage.',
  'query.countTasks': '{n} Aufgabe(n)',
  'query.toggleTask': 'Erledigt: {text}',
  'query.sortBy': 'Nach {field} sortieren',
  'query.editField': '{field} von {title}',
  'query.field.title': 'Titel',
  'query.field.updated': 'Geändert',
  'query.field.created': 'Erstellt',
  'query.field.folder': 'Ordner',
  'query.field.tags': 'Tags',
  'query.field.size': 'Zeichen',
  'css.title': 'Eigenes CSS',
  'css.hint':
    'Schnipsel, die die App umgestalten, Vorschau inklusive. Nichts wird nachgeladen: @import und Verweise auf andere Server werden entfernt, ein Schnipsel aus dem Netz kann also nichts zurückmelden. Exporte behalten ihr eigenes Aussehen — ein Dokument liest sich bei der Empfängerin so wie bei dir.',
  'css.add': 'Neuer Schnipsel',
  'css.name': 'Name des Schnipsels',
  'css.untitled': 'Schnipsel {n}',
  'css.enable': '„{name}“ verwenden',
  'css.delete': '„{name}“ löschen',
  'css.editorLabel': 'CSS für „{name}“',
  'css.placeholder': '.markbird-preview h1 { color: rebeccapurple; }',
  'css.removed': 'Entfernt, weil es von einem anderen Server laden würde: {what}',
  'css.escape':
    'Falls dein CSS die App unbenutzbar macht: mit ?nocss=1 öffnen oder in der Befehlspalette „Eigenes CSS ausschalten“ ausführen.',
  'css.offTitle': 'Dein CSS ist aus',
  'css.offBody': '{n} Schnipsel ausgeschaltet. Sie stehen weiter in den Einstellungen bereit.',
  'css.offNone': 'Es war nichts eingeschaltet.',
  'storage.title': 'Wo deine Notizen liegen',
  'storage.browser':
    'Deine Bibliothek liegt in diesem Browser. Exporte, Backups und die Ordner-Synchronisierung holen sie von diesem Gerät herunter.',
  'storage.native': 'Deine Notizen sind Dateien in {place}, auf diesem Gerät.',
  'storage.persisted': 'Dieser Browser hat zugesagt, sie zu behalten.',
  'storage.evictable':
    'Dieser Browser darf sie löschen, wenn der Speicher knapp wird. Bitte ihn, es nicht zu tun:',
  'storage.unknown': 'Dieser Browser sagt nicht, ob er sie löschen darf.',
  'storage.keep': 'Bibliothek behalten lassen',
  'storage.used': '{used} von etwa {quota} belegt',
  'folderSync.title': 'Mit einem Ordner synchronisieren',
  'folderSync.hint':
    'Halte deine Bibliothek und einen Ordner mit .md-Dateien auf diesem Computer in beide Richtungen auf demselben Stand. Bearbeite Notizen hier oder in einer anderen App; Änderungen auf einer Seite erscheinen auf der anderen.',
  'folderSync.noFolder': 'Keine Synchronisierung mit einem Ordner.',
  'folderSync.folderIs': 'Synchronisiert mit „{name}“.',
  'folderSync.choose': 'Ordner wählen…',
  'folderSync.change': 'Anderen Ordner wählen…',
  'folderSync.now': 'Jetzt synchronisieren',
  'folderSync.grant': 'Zugriff erlauben und synchronisieren',
  'folderSync.stop': 'Synchronisierung beenden',
  'folderSync.off': 'Aus.',
  'folderSync.pending': 'Wartet auf die erste Synchronisierung.',
  'folderSync.last': 'Zuletzt synchronisiert {date}',
  'folderSync.fromDisk': '{n} aus dem Ordner',
  'folderSync.toDisk': '{n} in den Ordner',
  'folderSync.moved': '{n} verschoben',
  'folderSync.trashed': '{n} in einen Papierkorb verschoben',
  'folderSync.permission':
    'Der Browser braucht erneut deine Erlaubnis für den Ordner. Klicke auf „Zugriff erlauben und synchronisieren“.',
  'folderSync.error':
    'Die letzte Synchronisierung konnte nicht abgeschlossen werden. Nichts ging verloren; sie versucht es erneut.',
  'folderSync.unsupported':
    'Die Synchronisierung mit einem Ordner braucht Chrome, Edge oder einen anderen Chromium-Browser auf einem Desktop-Computer.',
  'folderSync.confirmTitle': 'Bibliothek mit einem Ordner synchronisieren?',
  'folderSync.confirmBody':
    'Deine Dokumente werden als .md-Dateien in den Ordner geschrieben, und .md-Dateien, die schon darin liegen, kommen in deine Bibliothek. Danach werden Änderungen auf einer Seite auf die andere übertragen. Gelöschte Notizen landen hier im Papierkorb, dort im Ordner .markbird-trash. Ändert sich eine Notiz auf beiden Seiten zugleich, gewinnt die neuere Fassung, und die andere bleibt in der Versionshistorie.',
  'folderSync.conflicts':
    'Hier und im Ordner geändert: {titles}. Die ältere Fassung liegt in der Historie.',
  'github.title': 'Mit einem GitHub-Repository synchronisieren',
  'github.hint':
    'Halte deine Bibliothek mit einem Repository aus .md-Dateien im Gleichstand — in jedem Browser, auf jedem Gerät, ohne markbird-Konto. Das Repository ist der Speicher, den du ohnehin hast, und seine Historie ist deine Versionsgeschichte.',
  'github.repo': 'Repository',
  'github.branch': 'Branch',
  'github.path': 'Ordner im Repository (optional)',
  'github.token': 'Zugriffstoken',
  'github.tokenHint':
    'Lege auf GitHub ein fein abgestuftes Personal Access Token an, mit Lese- und Schreibrecht auf die Inhalte genau dieses Repositorys. Es bleibt nur auf diesem Gerät: Es wird nie synchronisiert, exportiert oder gesichert und geht an api.github.com und sonst nirgendwohin.',
  'github.connect': 'Verbinden',
  'github.connectedTo': 'Synchronisiert mit {name}.',
  'github.disconnect': 'Trennen',
  'github.notConnected': 'Nicht verbunden.',
  'github.reason.auth':
    'Das Token wurde abgelehnt. Prüfe, ob es Lese- und Schreibrecht auf die Inhalte dieses Repositorys hat.',
  'github.reason.repo': 'Kein Repository mit diesem Namen — oder das Token sieht es nicht.',
  'github.reason.branch': 'Das Repository gibt es, diesen Branch aber nicht.',
  'github.reason.error': 'GitHub war nicht erreichbar. Es wurde nichts geändert.',
  'github.confirmTitle': 'Bibliothek mit einem Repository synchronisieren?',
  'github.confirmBody':
    'Deine Dokumente werden als .md-Dateien nach {repo} committet, und .md-Dateien, die schon dort liegen, kommen in deine Bibliothek. Danach werden Änderungen auf einer Seite auf die andere übertragen. Gelöschte Notizen landen hier im Papierkorb, dort im Ordner .markbird-trash. Ändert sich eine Notiz auf beiden Seiten zugleich, gewinnt die neuere Fassung, und die andere bleibt in der Versionshistorie.',
  'publish.title': 'Ordner als Website veröffentlichen',
  'publish.hint':
    'Jede Notiz in einem Ordner wird eine Seite einer kleinen Website, mit einer Seitenliste und Links untereinander. Veröffentlicht wird eine Kopie: Spätere Änderungen hier ändern sie nicht, und ein erneutes Veröffentlichen ergibt eine neue Website.',
  'publish.folder': 'Ordner',
  'publish.name': 'Name der Website',
  'publish.address': 'Adresse',
  'publish.preview': 'Sie liegt dann unter {url}',
  'publish.pages': '{n} Seiten werden veröffentlicht.',
  'publish.noFolders':
    'Du hast noch keine Ordner. Lege die Notizen, die du veröffentlichen willst, zuerst in einen.',
  'publish.publish': 'Veröffentlichen',
  'publish.publishing': 'Wird veröffentlicht…',
  'publish.empty': 'In diesem Ordner liegt keine Notiz mit Inhalt.',
  'publish.done': 'Veröffentlicht — {n} Seiten, ein Link.',
  'publish.takeDown':
    'Der Link, der die Website wieder entfernt, bleibt auf diesem Gerät in deiner Linkliste. Ohne Konto ist er der einzige Weg zurück.',
  'publish.error.slug_taken': 'Diese Adresse ist schon vergeben. Nimm eine andere.',
  'publish.error.too_large':
    'Das ist mehr, als eine Website fassen kann. Veröffentliche einen kleineren Ordner.',
  'publish.error.rate_limited': 'Gerade zu viele Links von hier. Versuch es gleich noch einmal.',
  'publish.error.failed': 'Das Veröffentlichen hat nicht geklappt. Es wurde nichts veröffentlicht.',
  'site.pages': 'Seiten',
  'site.expired': 'Diese Website ist abgelaufen.',
  'site.deleted': 'Die Website wurde entfernt.',
  'site.deleteTitle': 'Diese Website entfernen',
  'site.deleteHint':
    'Du hast den Link geöffnet, der diese Website entfernt. Er löscht alle Seiten.',
  'site.deleteNow': 'Website entfernen',
  'backup.title': 'Lokale Backups',
  'backup.noFolder': 'Kein Backup-Ordner gewählt.',
  'backup.folderIs': 'Backup nach „{name}“.',
  'backup.choose': 'Ordner wählen…',
  'backup.cadence': 'Automatisches Backup',
  'backup.off': 'Aus',
  'backup.change': 'Bei jeder Änderung',
  'backup.daily': 'Einmal täglich',
  'backup.now': 'Jetzt sichern',
  'backup.last': 'Letztes Backup {date}',
  'backup.never': 'Noch kein Backup',
  'backup.zip': 'Backup herunterladen (.zip)',
  'backup.unsupported':
    'Ordner-Backups brauchen einen Chromium-Browser am Desktop. Du kannst trotzdem ein .zip-Backup herunterladen.',
  'backup.done': '{n} Dokument(e) gesichert.',
  'backup.failed': 'Backup fehlgeschlagen.',
  'backup.permission': 'Ordner-Berechtigung wurde verweigert.',

  // Account dialog
  'account.title': 'Konto & Daten',
  'account.exportH': 'Export',
  'account.exportBody': 'Lade alle Dokumente deiner Bibliothek als .zip aus .md-Dateien herunter.',
  'account.exportBtn': 'Alle Dokumente exportieren (.zip)',
  'account.exporting': 'Exportiere…',
  'account.exported': '{n} Dokumente als .zip exportiert.',
  'account.deleteH': 'Konto löschen',
  'account.deleteBody':
    'Löscht dein Konto und alle in die Cloud synchronisierten Dokumente unwiderruflich. Kopien auf diesem Gerät bleiben erhalten (nur lokal). Das kann nicht rückgängig gemacht werden.',
  'account.deleteBtn': 'Konto löschen…',
  'account.deleteConfirm': 'Ja, endgültig löschen',
  'account.deleting': 'Lösche…',
  'account.deleted': 'Konto gelöscht. Deine lokalen Dokumente bleiben auf diesem Gerät.',
  'account.reauth':
    'Aus Sicherheitsgründen bitte erneut anmelden und das Löschen dann wiederholen.',
  'account.deleteFail': 'Konto konnte nicht gelöscht werden: {msg}',
  'account.sharesDeleteFail':
    'Deine geteilten Links ließen sich nicht entfernen, daher wurde nichts gelöscht. Bitte versuch es erneut.',

  // Shortcuts
  'shortcuts.title': 'Tastaturkürzel',
  'shortcuts.general': 'Allgemein',
  'shortcuts.view': 'Ansicht',
  'shortcuts.formatting': 'Formatierung',
  'sc.palette': 'Befehlspalette',
  'sc.sheet': 'Diese Kürzel-Übersicht',
  'sc.new': 'Neues Dokument',
  'sc.find': 'Suchen & Ersetzen',
  'sc.sidebar': 'Seitenleiste umschalten',
  'sc.viewmode': 'Geteilt / Wechseln umschalten',
  'sc.pane': 'Aktiven Bereich wechseln',
  'sc.focus': 'Fokusmodus verlassen',
  'sc.bold': 'Fett',
  'sc.italic': 'Kursiv',
  'sc.code': 'Inline-Code',
  'sc.slash': 'Slash-Snippet-Menü',
  'sc.leaveEditor': 'Fokus aus dem Editor bewegen',
  'sc.tableCells': 'Nächste / vorherige Tabellenzelle (richtet die Tabelle aus)',
  'sc.today': 'Heutige Notiz öffnen',
  'sc.quickOpen': 'Dokument öffnen',

  // Auth dialog
  'auth.title': 'Anmelden',
  'auth.dialogTitle': 'Zum Synchronisieren anmelden',
  'auth.google': 'Weiter mit Google',
  'auth.github': 'Weiter mit GitHub',
  'auth.apple': 'Weiter mit Apple',
  'auth.appleUnavailable':
    'Die Apple-Anmeldung ist für diesen Build noch nicht freigeschaltet. Nutze vorerst einen anderen Weg.',
  'auth.emailLabel': 'E-Mail-Adresse',
  'auth.emailPlaceholder': 'du@beispiel.de',
  'auth.sendLink': 'Link per E-Mail senden',
  'auth.or': 'oder',
  'auth.checkInbox': 'Sieh in {email} nach dem Anmeldelink und öffne ihn auf diesem Gerät.',
  'auth.signinFail': 'Anmeldung fehlgeschlagen.',
  'auth.linkFail': 'Der Link konnte nicht gesendet werden.',
  'auth.confirmEmail': 'E-Mail-Adresse bestätigen, um die Anmeldung abzuschließen',
  'auth.optional':
    'Optional — markbird funktioniert vollständig offline, auch ohne Konto. Melde dich an, um deine Dokumente geräteübergreifend zu synchronisieren. Deine Notizen bleiben deine.',

  // Account button
  'acct.signIn': 'Anmelden',
  'acct.signInTitle': 'Zum Synchronisieren anmelden',
  'acct.account': 'Konto',
  'acct.manageShares': 'Geteilte Links verwalten…',
  'acct.accountData': 'Konto & Daten…',
  'acct.signOut': 'Abmelden',
  'sync.off': 'Nur lokal',
  'sync.connecting': 'Verbinde…',
  'sync.synced': 'Synchronisiert',
  'sync.error': 'Sync-Fehler',
  'sync.offline': 'Offline – Änderungen in Warteschlange',
  'encrypt.title': 'Verschlüsselung für synchronisierte Notizen',
  'encrypt.hint':
    'Mit einer Passphrase werden deine Notizen auf diesem Gerät verschlüsselt, bevor sie synchronisiert werden; markbirds Server speichert dann nur noch Chiffrat. Sichtbar bleibt, wie viele Notizen ein Konto hat und wann sich welche geändert hat — ohne das funktioniert Synchronisierung nicht.',
  'encrypt.signedOut':
    'Das betrifft die Synchronisierung. Abgemeldet verlassen deine Notizen dieses Gerät nie.',
  'encrypt.stateOff': 'Synchronisierte Notizen liegen im Klartext.',
  'encrypt.stateOn': 'Synchronisierte Notizen sind verschlüsselt, dieses Gerät kann sie lesen.',
  'encrypt.stateLocked':
    'Synchronisierte Notizen sind verschlüsselt. Dieses Gerät braucht die Passphrase.',
  'encrypt.turnOn': 'Synchronisierte Notizen verschlüsseln',
  'encrypt.turnOff': 'Verschlüsselung beenden',
  'encrypt.confirmTitle': 'Synchronisierte Notizen verschlüsseln?',
  'encrypt.confirmBody':
    'Wähle eine Passphrase. Sie verlässt deine Geräte nie — niemand, auch wir nicht, kann sie oder die Notizen in der Cloud wiederherstellen, wenn du sie verlierst. Die Notizen auf diesem Gerät bleiben so oder so lesbar. Jedes weitere Gerät fragt einmal nach der Passphrase.',
  'encrypt.choose': 'Passphrase wählen',
  'encrypt.repeat': 'Noch einmal eingeben',
  'encrypt.mismatchTitle': 'Die beiden stimmen nicht überein',
  'encrypt.mismatchBody': 'Es wurde nichts geändert. Versuch es in Ruhe noch einmal.',
  'encrypt.existsTitle': 'Dieses Konto ist bereits verschlüsselt',
  'encrypt.existsBody': 'Entsperre dieses Gerät stattdessen mit der gewählten Passphrase.',
  'encrypt.unlock': 'Passphrase für deine synchronisierten Notizen',
  'encrypt.unlockGo': 'Entsperren',
  'encrypt.wrongTitle': 'Diese Passphrase passt nicht',
  'encrypt.wrongBody': 'Es wurde nichts geändert. Deine Notizen auf diesem Gerät sind unberührt.',
  'encrypt.offTitle': 'Verschlüsselung beenden?',
  'encrypt.offBody':
    'Deine Notizen werden wieder im Klartext synchronisiert, und jede Kopie, die schon in der Cloud liegt, wird durch eine lesbare ersetzt.',
  'encrypt.lockedToast':
    'Deine synchronisierten Notizen sind verschlüsselt. Dieses Gerät braucht die Passphrase.',
  'sync.updated': 'Dieses Dokument wurde auf einem anderen Gerät geändert.',
  'sync.conflict':
    'Dieses Dokument wurde auf einem anderen Gerät bearbeitet. Deine vorherige Version ist gespeichert.',
  'sync.review': 'Vorherige Version ansehen',

  // PWA prompt
  'pwa.installTitle': 'markbird installieren',
  'pwa.installBody': 'markbird als App installieren.',
  'pwa.install': 'Installieren',
  'pwa.updateBody': 'Eine neue Version von markbird ist verfügbar.',
  'pwa.reload': 'Neu laden',
  'pwa.dismiss': 'Verwerfen',

  // Undo toast
  'undo.deleted': '„{title}“ in den Papierkorb verschoben.',
  'undo.undo': 'Rückgängig',

  // Share page
  'sp.readonly': 'Schreibgeschützt',
  'sp.editable': 'Bearbeitbar',
  'sp.save': 'Speichern',
  'sp.saving': 'Speichere…',
  'sp.saved': 'Gespeichert',
  'sp.retry': 'Erneut speichern',
  'sp.copyLib': 'In meine Bibliothek kopieren',
  'sp.open': 'markbird öffnen',
  'sp.loading': 'Lädt…',
  'report.open': 'Dieses Dokument melden',
  'report.title': 'Dieses Dokument melden',
  'report.intro':
    'Sag uns, was mit diesem geteilten Dokument nicht stimmt. Du brauchst dafür kein Konto.',
  'report.reasonLegend': 'Grund',
  'report.reason.illegal': 'Es ist rechtswidrig',
  'report.reason.copyright': 'Es verletzt Urheberrechte',
  'report.reason.personal_data': 'Es enthält meine personenbezogenen Daten',
  'report.reason.abuse': 'Belästigung, Spam oder Missbrauch',
  'report.reason.other': 'Etwas anderes',
  'report.details': 'Details (optional)',
  'report.contact': 'Deine E-Mail-Adresse (optional)',
  'report.contactHint': 'Nur für Rückfragen zu dieser Meldung.',
  'report.send': 'Meldung senden',
  'report.sending': 'Wird gesendet…',
  'report.failed': 'Die Meldung konnte nicht gesendet werden. Bitte versuch es erneut.',
  'report.sentTitle': 'Meldung eingegangen',
  'report.sentBody':
    'Danke. Wir prüfen das Dokument und entfernen es, wenn es gegen die Regeln verstößt.',
  'admin.title': 'Meldungen',
  'admin.loading': 'Meldungen werden geladen…',
  'admin.signedOut': 'Melde dich an, um Meldungen zu prüfen.',
  'admin.forbidden': 'Dieses Konto darf keine Meldungen prüfen.',
  'admin.error': 'Etwas ist schiefgelaufen. Lade die Seite neu.',
  'admin.empty': 'Keine offenen Meldungen.',
  'admin.reported': 'Gemeldet',
  'admin.document': 'Dokument',
  'admin.alreadyGone': 'Bereits entfernt',
  'admin.contact': 'Kontakt',
  'admin.remove': 'Freigabe entfernen',
  'admin.confirmRemove': 'Bestätigen: endgültig löschen',
  'admin.dismiss': 'Verwerfen',
  'editor.aria': 'Markdown-Quelltext',
  'preview.aria': 'Gerenderte Vorschau',
  'periodic.heading': 'Tages-, Wochen- und Monatsnotizen',
  'periodic.hint':
    'YYYY Jahr · MM Monat · DD Tag · dddd Wochentag · MMMM Monatsname · GGGG-[W]ww ISO-Woche. Text in [Klammern] bleibt, wie er ist.',
  'periodic.daily': 'Tagesnotizen',
  'periodic.weekly': 'Wochennotizen',
  'periodic.monthly': 'Monatsnotizen',
  'periodic.pattern': 'Titelmuster',
  'periodic.folder': 'Ordner',
  'periodic.root': 'Oberste Ebene',
  'periodic.preview': 'Heute: {title}',
  'periodic.problem.empty': 'Gib ein Muster ein.',
  'periodic.problem.not-unique':
    'Dieses Muster gäbe verschiedenen Zeiträumen denselben Titel — sie würden sich eine Notiz teilen.',
  'periodic.problem.inconsistent':
    'Dieses Muster benennt denselben Zeitraum an verschiedenen Tagen unterschiedlich — nutze bei Wochen GGGG statt YYYY.',
  'cmd.doc.today': 'Heutige Notiz öffnen',
  'cmd.doc.thisWeek': 'Notiz dieser Woche öffnen',
  'cmd.view.vaultMode': 'Vault-Modus umschalten (Wissensdatenbank)',
  'cmd.app.help': 'Hilfe & Support',
  'cmd.doc.template': 'Neu aus Vorlage…',
  'cmd.doc.trash': 'Papierkorb (Gelöschtes wiederherstellen)…',
  'cmd.backup.now': 'Bibliothek in Ordner sichern',
  'cmd.backup.zip': 'Bibliotheks-Backup herunterladen (.zip)',
  'cmd.backup.folder': 'Backup-Ordner wählen…',
  'cmd.view.vault.tags': 'Vault: Tags',
  'cmd.view.vault.links': 'Vault: offene Links & verwaiste Dokumente',
  'cmd.view.vault.graph': 'Vault: Graph',
  'cmd.view.vault.journal': 'Vault: Journal-Kalender',
  'cmd.doc.thisMonth': 'Notiz dieses Monats öffnen',
  'goal.promptTitle': 'Wortziel für dieses Dokument (0 entfernt es)',
  'goal.set': 'Ziel setzen',
  'goal.invalidTitle': 'Das ist kein Wortziel',
  'goal.invalidBody': 'Gib eine ganze Zahl an Wörtern ein, etwa 1000. 0 entfernt das Ziel.',
  'status.wordsOfGoal': '{n} / {goal} Wörter',
  'cmd.doc.wordGoal': 'Wortziel festlegen…',
  'settings.pageSize': 'PDF-Seitenformat',
  'settings.pageSize.auto': 'Beim Drucken wählen',
  'settings.pageSize.A4': 'A4',
  'settings.pageSize.Letter': 'US Letter',
  'settings.margins': 'PDF-Ränder',
  'settings.margins.narrow': 'Schmal',
  'settings.margins.normal': 'Normal',
  'settings.margins.wide': 'Breit',
  'settings.exportToc': 'PDFs mit Inhaltsverzeichnis beginnen',
  'export.toc': 'Inhalt',
  'mermaid.offlineType':
    'Dieses Diagramm lässt sich offline noch nicht zeichnen. Es erscheint, sobald du wieder online bist.',
  'share.expires': 'Der Link funktioniert bis {date}.',
  'shareOpt.90d': '90 Tage',
  'shareOpt.anonExpiry':
    'Ohne Konto erstellte Links laufen immer ab — spätestens nach 90 Tagen —, weil es kein Konto gibt, in dem sie aufgelistet und zurückgezogen werden könnten. markbird merkt sich den Link auf diesem Gerät, du kannst ihn also früher löschen.',
  'shareMgr.localTitle': 'Links von diesem Gerät',
  'shareMgr.localExplainer':
    'Hier erstellte Links, auch die ohne Konto. Dieses Gerät hat das Geheimnis, mit dem sie sich löschen lassen — bewahre den Lösch-Link auf, falls du ihn woanders brauchst.',
  'shareMgr.localEmpty': 'Auf diesem Gerät wurden keine Links erstellt.',
  'shareMgr.copyDeleteLink': 'Lösch-Link kopieren',
  'sp.deleteTitle': 'Diese geteilte Kopie löschen',
  'sp.deleteHint': 'Du hast einen Lösch-Link für diese geteilte Kopie geöffnet.',
  'sp.deleteNow': 'Geteilte Kopie löschen',
  'sp.deleting': 'Wird gelöscht…',
  'sp.deleted': 'Die geteilte Kopie wurde gelöscht.',
  'sp.deleteFailed': 'Dieser Lösch-Link gehört nicht zu dieser Freigabe.',
  'sp.invalid': 'Dieser Link ist ungültig oder abgelaufen.',
  'sp.notAvailable': 'Nicht verfügbar',
  'sp.goto': 'Zu markbird',
  'sp.titlePlaceholder': 'Ohne Titel',
  'sp.peers': '{n} bearbeiten',
  'sp.peersTitle': 'Personen, die dieses Dokument gerade bearbeiten',
  'sp.protectedTitle': 'Passwort erforderlich',
  'sp.protectedHint': 'Dieses geteilte Dokument ist passwortgeschützt.',
  'sp.wrongPassword': 'Falsches Passwort. Bitte erneut versuchen.',
  'sp.unlock': 'Entsperren',

  // Command palette
  'cmdk.placeholder': 'Befehl eingeben oder Dokumente suchen…',
  'cmdk.empty': 'Keine Treffer.',
  'cmdk.openDoc': 'Dokument öffnen',
  'cmdk.quickOpen': 'Dokument öffnen',
  'cmdk.quickOpenPlaceholder': 'Alle Dokumente nach Titel, Alias oder Ordner durchsuchen…',

  // Version history
  'history.title': 'Versionsverlauf',
  'history.empty': 'Noch keine Versionen. Der Verlauf wird beim Schreiben automatisch erfasst.',
  'history.saveNow': 'Aktuelle Version speichern',
  'history.restore': 'Diese Version wiederherstellen',
  'history.restoring': 'Stelle wieder her…',
  'history.reason.auto': 'Autospeichern',
  'history.reason.restore': 'Vor Wiederherstellung',
  'history.reason.remote': 'Vor Sync',
  'cmd.doc.history': 'Versionsverlauf…',

  // Command palette groups
  'grp.Document': 'Dokument',
  'grp.View': 'Ansicht',
  'grp.Export': 'Export',
  'grp.Share': 'Teilen',
  'grp.Appearance': 'Darstellung',
  'grp.Editor': 'Editor',
  'grp.Account': 'Konto',

  // Commands
  'cmd.doc.new': 'Neues Dokument',
  'cmd.doc.duplicate': 'Aktuelles Dokument duplizieren',
  'cmd.doc.import': 'Markdown-Datei(en) importieren…',
  'cmd.doc.openFile': 'Datei von der Festplatte öffnen…',
  'cmd.doc.saveFile': 'In Datei speichern (Festplatte)',
  'cmd.doc.saveFileAs': 'Kopie auf Festplatte speichern…',
  'cmd.doc.delete': 'Aktuelles Dokument löschen',
  'cmd.doc.emptyTrash': 'Papierkorb leeren (endgültig)',
  'cmd.view.toggleMode': 'Ansicht umschalten (geteilt / wechseln)',
  'cmd.view.switchPane': 'Aktiven Bereich wechseln (Quelle / Vorschau)',
  'cmd.view.toggleSidebar': 'Seitenleiste umschalten',
  'cmd.view.toggleOutline': 'Gliederung umschalten (Inhaltsverzeichnis)',
  'cmd.view.focusMode': 'Fokusmodus umschalten (Zen)',
  'cmd.editor.table.insert': 'Tabelle: einfügen',
  'cmd.editor.table.format': 'Tabelle: Spalten ausrichten',
  'cmd.editor.table.addRowBelow': 'Tabelle: Zeile darunter einfügen',
  'cmd.editor.table.addColumnRight': 'Tabelle: Spalte rechts einfügen',
  'cmd.editor.table.deleteRow': 'Tabelle: Zeile löschen',
  'cmd.editor.table.deleteColumn': 'Tabelle: Spalte löschen',
  'cmd.editor.table.cycleAlign': 'Tabelle: Spaltenausrichtung wechseln',
  'table.notInTable': 'Keine Tabelle',
  'table.notInTableBody':
    'Setze den Cursor zuerst in eine Tabelle. Tabellen brauchen eine Kopfzeile und eine Trennzeile wie | --- | --- |.',
  'cmd.editor.find': 'Suchen & Ersetzen',
  'cmd.editor.typewriter': 'Schreibmaschinen-Scrollen umschalten',
  'cmd.editor.toggleVim': 'Vim-Modus umschalten',
  'cmd.app.settings': 'Einstellungen…',
  'cmd.app.shortcuts': 'Tastaturkürzel',
  'cmd.export.md': 'Als Markdown (.md) exportieren',
  'cmd.export.html': 'Als HTML exportieren',
  'cmd.export.pdf': 'Als PDF exportieren',
  'cmd.export.docx': 'Als DOCX (Word) exportieren',
  'cmd.export.slides': 'Als Folien (HTML) exportieren',
  'cmd.export.copyHtml': 'Gerendertes HTML kopieren',
  'cmd.export.copyMarkdown': 'Markdown kopieren',
  'cmd.share.create': 'Schreibgeschützten Link teilen',
  'cmd.share.options': 'Mit Optionen teilen (Zugriff + Ablauf)…',
  'cmd.share.createEdit': 'Bearbeitbaren Link teilen',
  'cmd.share.manage': 'Geteilte Links verwalten…',
  'cmd.appearance.cycleTheme': 'Design wechseln (auto / hell / dunkel)',
  'cmd.appearance.light': 'Design: Hell',
  'cmd.appearance.dark': 'Design: Dunkel',
  'cmd.appearance.system': 'Design: System',
  'cmd.account.signOut': 'Abmelden',
  'cmd.account.signIn': 'Zum Synchronisieren anmelden…',
  'cmd.account.settings': 'Konto & Daten (alle exportieren, Konto löschen)…',
  'cmd.confirm.emptyTrash': 'Alle Dokumente im Papierkorb endgültig löschen?',

  /* Wissensdatenbank (Vault-Modus) */
  'common.loading': 'Wird geladen…',
  'tags.inline': 'Steht als #tag im Text — dort bearbeiten.',
  'embed.missing': '„{target}“ kann nicht eingebettet werden — kein solches Dokument.',
  'embed.missingSection':
    '„{section}“ kann nicht eingebettet werden — in diesem Dokument nicht gefunden.',
  'embed.truncated': '„{target}“ ist weiter oben eingebettet und wird hier nicht wiederholt.',
  'vault.title': 'Vault',
  'vault.tags': 'Schlagwörter',
  'vault.links': 'Verweise',
  'vault.graph': 'Graph',
  'vault.journal': 'Journal',
  'journal.hasNote': 'Notiz vorhanden',
  'journal.previousMonth': 'Vorheriger Monat',
  'journal.nextMonth': 'Nächster Monat',
  'journal.openMonth': 'Notiz für {month} öffnen',
  'journal.openWeek': 'Notiz für KW {week} öffnen',
  'journal.week': 'Kalenderwoche',
  'journal.weekShort': 'KW',
  'journal.today': 'Heute',
  'vault.noTags':
    'Noch keine Schlagwörter. Füge sie in den Eigenschaften hinzu oder schreibe #tag in den Text.',
  'vault.unresolved': 'Unaufgelöste Verweise',
  'vault.noUnresolved': 'Jeder [[Verweis]] führt irgendwohin.',
  'vault.createNote': '„{title}“ anlegen',
  'vault.orphans': 'Verwaiste Dokumente',
  'vault.noOrphans': 'Jedes Dokument ist verbunden.',
  'graph.title': 'Verweisgraph',
  'graph.scope': 'Graph-Umfang',
  'graph.local': 'Um diese Notiz',
  'graph.global': 'Ganzer Vault',
  'graph.empty': 'Noch nichts zu zeichnen — verbinde Dokumente mit [[Verweisen]].',
  'graph.trimmed': 'Zeigt die {n} am stärksten verbundenen Dokumente.',
  'sidebar.showMore': 'Mehr anzeigen',
};
